import React from "react";
import {FormControlLabel, Checkbox} from "@material-ui/core";
import UserSelect from "./user_filter";
import _ from "lodash";
import {styled} from "styled-components";
import {User, UserId} from "common/types/user";
import {ConversationUserInfo} from "common/types/conversation";

interface QueryHistoryFiltersProps {
  currentUser: User;
  shownUserIds: UserId[];
  onShowOnlyCurrentUserChats: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  onShownUserIdsChange: (newUserIds: UserId[]) => void;
  users: ConversationUserInfo[];
}

const FiltersContainer = styled.div`
  padding: 0.5em;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

const QueryHistoryFilters: React.FC<QueryHistoryFiltersProps> = ({
  currentUser,
  shownUserIds,
  onShownUserIdsChange,
  onShowOnlyCurrentUserChats,
  users,
}) => {
  return (
    <FiltersContainer>
      <div style={{display: "flex", alignItems: "center"}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={_.isEqual(shownUserIds, [currentUser.id])}
              onChange={onShowOnlyCurrentUserChats}
              color="primary"
            />
          }
          label="Only show your chats"
        />

        <UserSelect
          users={users}
          shownUserIds={shownUserIds}
          setShownUserIds={onShownUserIdsChange}
        />
      </div>
    </FiltersContainer>
  );
};

export default QueryHistoryFilters;
